import { useCallback, useMemo } from "react";

import { putData } from "@api/crud";
import { apiUsersEndpoints } from "@api/Endpoints";

import {
  AzureApplicationUserModel,
  UpdateApiUserRequest
} from "../models/api-users-models";

export function useUpdateApiUser() {
  const updateCallback = useCallback(
    async (organizationId: string, apiUserId: string, newName: string) => {
      const url = apiUsersEndpoints.updateApiUser();

      const request: UpdateApiUserRequest = {
        organizationId: organizationId,
        apiUserId: apiUserId,
        displayName: newName
      };

      return await putData<UpdateApiUserRequest, AzureApplicationUserModel>(
        url,
        request
      );
    },
    []
  );

  return useMemo(
    () => ({
      updateApiUser: updateCallback
    }),
    [updateCallback]
  );
}
